
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { GlobalComponent } from "src/app/global-component";

import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { IntervalEnum } from "src/app/core/enums/intervals-enum";

export class FiniteStateMachinesListConfig extends TableConfigurationModel {

     constructor() {
        super();
        this.listTitle = "Finite State Machines List";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {

                dataFieldName: 'name',
                title: 'Name',
                sortable: new SortByValuesModel('name'),
                visible: 'true',
                order: 1,
                width: "70px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'interval',
                title: 'Interval',
                sortable: new SortByValuesModel('interval'),
                visible: 'true',
                order: 2,
                width: "200px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: IntervalEnum,
                    switchOptions: [
                        { case: undefined, return: '' }
                    ]
                },
                customStatusText: {
                    type: IntervalEnum,
                    switchOptions: [
                        { case: IntervalEnum.OneMinute, return: $localize`:@@FSM_Status_Text_One_Minute:One Minute` },
                        { case: IntervalEnum.TwoMinutes, return: $localize`:@@FSM_Status_Text_Two_Minutes:Two Minutes` },
                        { case: IntervalEnum.FiveMinutes, return: $localize`:@@FSM_Status_Text_Five_Minutes:Five Minutes` },
                        { case: IntervalEnum.ThirtyMinutes, return: $localize`:@@FSM_Status_Text_Thirty_Minutes:Thirty Minutes` },
                        { case: IntervalEnum.OneHour, return: $localize`:@@FSM_Status_Text_One_Hour:One Hour` },
                        { case: IntervalEnum.FourHours, return: $localize`:@@FSM_Status_Text_Four_Hours:Four Hours` },
                        { case: IntervalEnum.SixHours, return: $localize`:@@FSM_Status_Text_Six_Hours:Six Hours` },
                        { case: IntervalEnum.TwelveHours, return: $localize`:@@FSM_Status_Text_Twelve_Hours:Twelve Hours` },
                        { case: IntervalEnum.OneDay, return: $localize`:@@FSM_Status_Text_One_Day:One Day` },
                        { case: IntervalEnum.OneWeek, return: $localize`:@@FSM_Status_Text_One_Week:One Week` },
                        { case: IntervalEnum.OneMonth, return: $localize`:@@FSM_Status_Text_One_Month:One Month` },
                        { case: IntervalEnum.EndOfDay, return: $localize`:@@FSM_Status_Text_End_Of_Day:End Of Day` },
                        { case: IntervalEnum.EndOfMonth, return: $localize`:@@FSM_Status_Text_End_Of_Month:End Of Month` },
                        { case: IntervalEnum.EndOfYear, return: $localize`:@@FSM_Status_Text_End_Of_Year:End Of Year` },
                        { case: undefined, return: $localize`:@@FSM_Status_Text_Error: No Defined Interval` },
                    ]
                }
            },

            {
                dataFieldName: 'createdDate',
                title: 'Created Date',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "150px",
                type: ColumnTypeEnum.Date
            },
            {
                dataFieldName: 'modifiedDate',
                title: 'Modified Date',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 4,
                width: "150px",
                type: ColumnTypeEnum.Date
            },
            {
                dataFieldName: 'isEnabled',
                title: 'Status',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 5,
                width: "125px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: EntityTypeEnum,
                    switchOptions: [
                        { case: true, return: 'coloredTextArea green' },
                        { case: false, return: 'coloredTextArea red' },
                        { case: undefined, return: 'coloredTextArea purple' }
                    ]
                },
                customStatusText: {
                    type: EntityTypeEnum,
                    switchOptions: [
                        { case: true, return: 'Enabled' },
                        { case: false, return: 'Disabled' },
                        { case: undefined, return: 'Other' }
                    ]
                }
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 6,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.filters = [
            {
                label: 'status',
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:Select Status`, $localize`:@@:Select Status`, undefined, true),
                    new NgSelectListModel(true, $localize`:@@Contact_Status_Enabled:Enabled`, $localize`:@@Contact_Status_Enabled:Enabled`, "bx bx-check-circle"),
                    new NgSelectListModel(false, $localize`:@@Contact_Status_Disabled:Disabled`, $localize`:@@Contact_Status_Disabled:Disabled`, "bx bx-error-alt"),
                ],
                selectedOption: undefined,
                inDropdown: true,
                inHeading: false,
                inButton: false,
            }
        ]
        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search for machine name"
        }
        this.actions = [
            {
                visible: SecurityOperations.importExport.importExportManagement,
                label: 'Enable',
                actionId: ActionIdEnum.EnableDisable,
                icon: 'ri-play-circle-line',
                inDropdown: true,
                inList: false,
                visibleOnValues: [0],
                visibilityByValueIsEnum: true,
                dataFieldName: 'isEnabled'
            },
            {
                visible: SecurityOperations.importExport.importExportManagement,
                label: 'Disable',
                actionId: ActionIdEnum.EnableDisable,
                icon: 'ri-stop-circle-line',
                inDropdown: true,
                inList: false,
                visibleOnValues: [1],
                visibilityByValueIsEnum: true,
                dataFieldName: 'isEnabled'
            },
            {
                visible: SecurityOperations.importExport.importExportManagement,
                label: 'Edit',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-edit-line',
                inDropdown: true,
                inList: false
            },
            {
                visible: SecurityOperations.importExport.importExportManagement,
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-delete-bin-fill',
                inDropdown: true,
                inList: false
            },
        ]
        this.buttons = [
            {
                visible: SecurityOperations.account.accountCreate,
                label: "Create New",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default
            },
            {
                visible: SecurityOperations.file.fileDelete,
                label: undefined,
                iconIsAfterLabel: true,
                action: ButtonIdEnum.Delete,
                color: "btn-primary",
                icon: "ri-delete-bin-fill",
                type: ButtonTypeEnum.CheckBoxSelected,
            }
        ]
    }
}